import { render, staticRenderFns } from "./ReportingBatches.vue?vue&type=template&id=27754052&scoped=true&lang=pug&"
import script from "./ReportingBatches.vue?vue&type=script&lang=js&"
export * from "./ReportingBatches.vue?vue&type=script&lang=js&"
import style0 from "./ReportingBatches.vue?vue&type=style&index=0&id=27754052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27754052",
  null
  
)

export default component.exports